import Scoreboard from '@/components/horizontalWidget/Scoreboard';
import { pack } from 'react_rails/pack';
import { useState, useEffect } from 'react';
import { createContainer } from 'containers';
import merge from 'helpers/merge';
import { useActiveGames } from 'stores/activeGamesStore';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { WidgetsV5ShowQuery, WidgetsV5ShowQueryVariables, rubyQueries } from 'queries';

dayjs.extend(isToday);

export interface GamesContainerProps {
  query: WidgetsV5ShowQuery;
  variables: WidgetsV5ShowQueryVariables;
}

export const [GamesContainer, useGamesContainer] = createContainer(({ query, variables }: GamesContainerProps) => {
  const [state, setState] = useState({
    games: query.schoolWidget.source.games.nodes,
    isLoadingMore: false,
    hasNextPage: query.schoolWidget.source.games.pageInfo.hasNextPage,
    endCursor: query.schoolWidget.source.games.pageInfo.endCursor
  });

  const activeGames = useActiveGames(dayjs(variables.date).isToday());

  useEffect(() => {
    setState(state => ({ ...state, games: state.games.map(game => merge(game, activeGames[game.id] || {})) }));
  }, [activeGames]);

  useEffect(() => {
    if (!state.isLoadingMore) return;

    rubyQueries.widgetsV5ShowQuery(30, { ...variables, after: state.endCursor }).then(
      ({
        schoolWidget: {
          source: {
            games: { nodes, pageInfo }
          }
        }
      }) => {
        setState(state => ({
          ...state,
          isLoadingMore: false,
          games: [...state.games, ...nodes],
          ...pageInfo
        }));
      }
    );
  }, [state.isLoadingMore]);

  function loadNextPage() {
    if (state.isLoadingMore || !state.hasNextPage) return;
    setState(state => ({ ...state, isLoadingMore: true }));
  }

  return [
    {
      games: state.games,
      genderSports: query.schoolWidget.source.gender_sports,
      variables
    },
    {
      loadNextPage
    }
  ];
});

interface ScoreboardHorizontalPageProps extends GamesContainerProps {
  showSBLAd: boolean;
}

export default pack(function Show({ showSBLAd, variables, ...props }: ScoreboardHorizontalPageProps) {
  return (
    <GamesContainer {...props} variables={variables}>
      <Scoreboard showSBLAd={showSBLAd} widgetId={variables.id} />
    </GamesContainer>
  );
});
